import { Header } from "@/components/Header";
import type { DetailsLayoutProps } from "./DetailsLayoutProps";
import classes from "./DetailsLayout.module.scss";
import { clsx } from "clsx";
import { Footer } from "@/components/Footer";
import { Container } from "@/components/ui/Container";
import { Heading } from "@/components/ui/Heading";
import DetailsLayoutSidebar from "./DetailsLayoutSidebar";
import { useAppConfig } from "@/hooks/useAppConfig";

export function DetailsLayout(props: DetailsLayoutProps) {
  const { children, className } = props;

  const { title } = useAppConfig();

  return (
    <div className={clsx(classes.page, className)}>
      <Header />

      <main className={classes.main}>
        <Container maxWidth="lg">
          <div className={classes.title}>
            <Heading size="3xl" align="center">
              {title}
            </Heading>
          </div>
          <div className={classes.layout}>
            <div className={classes.content}>{children}</div>

            <DetailsLayoutSidebar />
          </div>
        </Container>
      </main>

      <Footer />
    </div>
  );
}
